import { Spinner } from "@heroui/react";

export function RouteFallback() {
	return (
		<div className="flex min-h-[40vh] w-full items-center justify-center" role="status" aria-live="polite">
			<Spinner />
		</div>
	);
}
